import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"

import { computed } from 'vue';

/**
 * TYPES
 */
type Props = {
  width: string | number;
  bufferWidth: string | number;
  size?: string;
  color?: string;
  changeType?: string;
};

/**
 * PROPS
 */

export default _defineComponent({
  props: {
    width: { type: [String, Number], required: true },
    bufferWidth: { type: [String, Number], required: true },
    size: { type: String, required: false, default: '1' },
    color: { type: String, required: false, default: 'green' },
    changeType: { type: String, required: false, default: '' }
  } as unknown as undefined,
  setup(__props: {
  width: string | number;
  bufferWidth: string | number;
  size?: string;
  color?: string;
  changeType?: string;
}) {

const props = __props


/**
 * COMPUTED
 */
const barClasses = computed(() => {
  if (props.changeType)
    return {
      [`h-${props.size}`]: true,
      [`bg-${props.color}`]: true
    };
  return {
    [`h-${props.size}`]: true,
    [`bg-${props.color}-400`]: true
  };
});

const bufferBarClasses = computed(() => ({
  [`h-${props.size}`]: true,
  [`bg-yellow-500`]: true
}));

const barStyles = computed(() => ({
  width: `${props.width}%`
}));

const bufferBarStyles = computed(() => ({
  width: `${props.bufferWidth}%`
}));

const trackCls = computed(() => {
  if (props.changeType === 'createPool') {
    return {
      'progress-track-create': true
    };
  } else if (props.changeType === 'trade') {
    return {
      'progress-track-trade': true
    };
  } else if (props.changeType === 'withdraw') {
    return {
      'progress-track-trade': true
    };
  } else if (props.changeType === 'invest') {
    return {
      'progress-track-trade': true
    };
  } else if (props.changeType === 'invest') {
    return {
      'progress-track-boost': true
    };
  } else {
    return {
      'progress-track': true
    };
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(trackCls))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['progress-bar', _unref(barClasses)]),
      style: _normalizeStyle(_unref(barStyles))
    }, null, 6),
    (props.bufferWidth != null && props.bufferWidth > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['progress-bar', _unref(bufferBarClasses)]),
          style: _normalizeStyle(_unref(bufferBarStyles))
        }, null, 6))
      : _createCommentVNode("", true)
  ], 2))
}
}

})